// Hack to get fancybox to load (use require rather than import)
var $ = require('jquery');
window.jQuery = $;
require('@fancyapps/fancybox');
import * as sections from '@shopify/theme-sections';
import Subscription from '../templates/customers/subscription';
import slideshows from '../components/slideshows';

BOLD.recurring_orders.setSettings({
    loadOnDuplicateProductForms: true,
}, true);

export default function quickview() {
  $(function() {
    $(document).on('click', 'button.quickview-trigger', function(e) {
      e.preventDefault();
      $.fancybox.open({
        baseClass: 'quick-view',
        src: $(e.target).attr('href') + '?view=quickview',
        type: 'ajax',
        afterLoad: function(instance, slide) {
          sections.load('product');
          slideshows();
          Subscription();
          window.BOLD.recurring_orders.app.reboot()
          window.yotpo.initWidgets();
          // trigger an event that the cart drawer can pick up
          var evt = document.createEvent('Event');
          evt.initEvent('quickviewloaded', true, true);
          evt.quickview = instance;
          slide.$slide[0].dispatchEvent(evt);
        }
      });
    });
  });
}
